import React, { MouseEventHandler } from 'react';
import { ButtonRowView } from '../../Buttons/ButtonRowView';

type TTakePhotoProps = {
    label?: string;
    iconName?: string;
    handleClick: MouseEventHandler;
};
const TakePhoto = ({ label, iconName, handleClick }: TTakePhotoProps) => {
    return <ButtonRowView label={label} iconName={iconName} onClick={handleClick} />;
};
export { TakePhoto };
